module.exports = __webpack_public_path__ + "static/media/rainy-2.35eb268d.svg";